import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { L10nHTML, useL10n } from '@uplift/hooks';
import { useAppointmentRemindersQuery } from '@uplift/queries';
import { AssessmentKeys } from '@uplift/types';


const getAssessmentWarningLabel = (assessmentKey: AssessmentKeys, score: number) => {
  if (assessmentKey === 'phq9') {
    if (score >= 15 && score <= 19) {
      return 'Moderately Severe';
    } else if (score >= 20 && score <= 27) {
      return 'Severe';
    }
  } else if (assessmentKey === 'gad7') {
    if (score >= 13 && score <= 14) {
      return 'Moderately Severe';
    } else if (score >= 15 && score <= 21) {
      return 'Severe';
    }
  }

  return null;
};


const useStyles = makeStyles()(theme => ({
  root: {
    paddingLeft: theme.spacing(1),

    '& ::marker': {
      content: '"• "',
    }
  },
}));


export type AppointmentRemindersProps = {
  appointmentId: string;
};


export const AppointmentReminders: React.FC<AppointmentRemindersProps> = (props) => {
  const l10n = useL10n();
  const { classes } = useStyles();
  const { data: reminders = [] } = useAppointmentRemindersQuery(props.appointmentId);

  if (reminders.length === 0) {
    return <Typography color="textSecondary" component="i">No reminders—you’re all set</Typography>;
  }

  return (
    <Typography className={classes.root}>
      {reminders.map(reminder => {
        if (reminder.type === 'assessment') {
          return (
            <li key={reminder.name}>
              {reminder.name} score: <strong>{reminder.score} — {getAssessmentWarningLabel(reminder.key, reminder.score)?.toLowerCase?.()}</strong>
            </li>
          );
        } else if (reminder.type === 'psychiatry_session') {
          return (
            <li key={reminder.key}>
              <L10nHTML>{l10n.appointments.reminders[reminder.key]}</L10nHTML>
            </li>
          );
        } else if (reminder.type === 'raw') {
          return (
            <li key={reminder.message}>
              {reminder.message}
            </li>
          );
        }

        const str = JSON.stringify(reminder, undefined, 4);

        return (
          <li key={str}>
            <pre>
              <code>
                {str}
              </code>
            </pre>
          </li>
        );
      })}
    </Typography>
  );
};
